import React, { useEffect, useMemo, useState } from 'react';
import BaseDialog from '../BaseDialog';
import useApiControl from '../../../common/useApiControl';
import { Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
// import Button from '@mui/material/Button';

const CheckEventCheckOutDialog = ({ isVisible, onClose, event, round, dialogMode, containerRef, completionReason = 'owner_ended' }) => {

    const params = {
        eid: event.id,
        completion_reason: completionReason,
    };

    const { data: data1, loading: loading1, executeRequest: executeRequest1 } = useApiControl({
        action: '/check_out_event',
        params: params,
        method: 'POST',
    });

    const handleonClick = () => {
        executeRequest1().then(() => {
            debugger;
            onClose();
        });
    };

    if (round.starttime == null || round.starttime == '') {
        return (
            <BaseDialog isVisible={isVisible} onClose={onClose} dialogMode={dialogMode} containerRef={containerRef}>
                <div style={{ maxWidth: '400px', padding: '16px' }}>
                    ルームを終了しますか？
                </div>
                <div style={{ maxWidth: '400px', padding: '16px' }}>
                    終了すると、ルームの最終的な結果が表示されます。
                    新しいラウンドの開始やベット、参加者の追加はできなくなります。
                    終了後も、最終結果やランキングの確認、チャットの利用は引き続き可能です。
                    この操作は元に戻せません。
                </div>
                <Button
                    onClick={handleonClick}
                >
                    終了
                </Button>
            </BaseDialog>
        );
    } else {
        return (
            <BaseDialog isVisible={isVisible} onClose={onClose} dialogMode={dialogMode} containerRef={containerRef}>
                <div style={{ maxWidth: '400px', padding: '16px' }}>
                    ラウンド進行中のルームは終了できません
                </div>
            </BaseDialog>
        );


    }
};

export default CheckEventCheckOutDialog;
